// File: app/javascript/packs/calendar_filter.js

document.addEventListener('turbolinks:load', () => {
  // Check if we're on the calendar page
  const calendarContainer = document.getElementById('calendar-container');
  if (!calendarContainer) return;

  const filterButtons = document.querySelectorAll('.calendar-filter-btn');
  const calendarItems = document.querySelectorAll('.calendar-item');
  const calendarSections = document.querySelectorAll('.calendar-section');
  const noResultsMessage = document.getElementById('calendar-no-results');
  const calendarContent = document.getElementById('calendar-content');
  const overviewSection = document.getElementById('overview-section');
  const dailyBreakdown = document.getElementById('daily-breakdown');
  const detailedBreakdown = document.getElementById('detailed-breakdown');

  if (filterButtons.length === 0) return;

  // Set initial active state
  let activeFilter = 'all';

  filterButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const filter = button.getAttribute('data-filter');

      // Update active button styles
      filterButtons.forEach(btn => {
        const btnFilter = btn.getAttribute('data-filter');
        if (btnFilter === filter) {
          // Active state - filled background
          btn.classList.remove('bg-white');
          btn.classList.add(getActiveBackground(btnFilter));
          btn.classList.add('text-white');
          btn.classList.remove(getTextColor(btnFilter));
        } else {
          // Inactive state - outline only
          btn.classList.add('bg-white');
          btn.classList.remove(getActiveBackground(btnFilter));
          btn.classList.remove('text-white');
          btn.classList.add(getTextColor(btnFilter));
        }
      });

      activeFilter = filter;
      applyFilter(filter);
    });
  });

  function getActiveBackground(filter) {
    switch (filter) {
      case 'all': return 'bg-[#491363]';
      case 'not_completed': return 'bg-red-500';
      case 'completed': return 'bg-green-500';
      case 'elections': return 'bg-indigo-500';
      default: return 'bg-gray-500';
    }
  }

  function getTextColor(filter) {
    switch (filter) {
      case 'all': return 'text-[#491363]';
      case 'not_completed': return 'text-red-700';
      case 'completed': return 'text-green-700';
      case 'elections': return 'text-indigo-700';
      default: return 'text-gray-700';
    }
  }

  function applyFilter(filter) {
    let visibleCount = 0;

    // Handle section reordering for weekly/monthly view
    if (calendarContent && overviewSection && dailyBreakdown) {
      if (filter === 'not_completed' || filter === 'completed') {
        // Move overview section to the top
        calendarContent.insertBefore(overviewSection, dailyBreakdown);
        overviewSection.classList.remove('mt-12', 'pt-8', 'border-t-2', 'border-gray-300');
        overviewSection.classList.add('mb-12', 'pb-8', 'border-b-2', 'border-gray-300');
      } else {
        // Move overview section back to the bottom
        calendarContent.appendChild(overviewSection);
        overviewSection.classList.add('mt-12', 'pt-8', 'border-t-2', 'border-gray-300');
        overviewSection.classList.remove('mb-12', 'pb-8', 'border-b-2', 'border-gray-300');
      }
    }

    // Handle detailed breakdown visibility for monthly view
    if (detailedBreakdown) {
      if (filter === 'all') {
        detailedBreakdown.classList.remove('hidden');
      } else {
        // Show detailed breakdown only if there are visible items
        const detailedItems = detailedBreakdown.querySelectorAll('.calendar-item');
        const hasVisibleDetailedItems = Array.from(detailedItems).some(item => {
          const itemType = item.getAttribute('data-filter-type');
          return itemType === filter;
        });
        if (hasVisibleDetailedItems) {
          detailedBreakdown.classList.remove('hidden');
        } else {
          detailedBreakdown.classList.add('hidden');
        }
      }
    }

    if (filter === 'all') {
      // Show all items
      calendarItems.forEach(item => {
        item.classList.remove('hidden');
        visibleCount++;
      });
      calendarSections.forEach(section => {
        section.classList.remove('hidden');
      });
      // Show all calendar days
      const calendarDays = document.querySelectorAll('.calendar-day');
      calendarDays.forEach(day => {
        day.classList.remove('hidden');
      });
    } else {
      // Filter items by type
      calendarItems.forEach(item => {
        const itemType = item.getAttribute('data-filter-type');
        if (itemType === filter) {
          item.classList.remove('hidden');
          visibleCount++;
        } else {
          item.classList.add('hidden');
        }
      });

      // Hide sections that have no visible items
      calendarSections.forEach(section => {
        const sectionItems = section.querySelectorAll('.calendar-item');
        const visibleItems = Array.from(sectionItems).filter(item => !item.classList.contains('hidden'));
        if (visibleItems.length === 0) {
          section.classList.add('hidden');
        } else {
          section.classList.remove('hidden');
        }
      });

      // Hide calendar days that have no visible content
      // But don't hide grid cells in monthly view (those are inside #daily-breakdown with grid layout)
      const calendarDays = document.querySelectorAll('.calendar-day');
      calendarDays.forEach(day => {
        // Check if this day is inside the detailed breakdown (can be hidden)
        // or inside the monthly grid (should not be hidden to preserve grid layout)
        const isInDetailedBreakdown = detailedBreakdown && detailedBreakdown.contains(day);
        const isInMonthlyGrid = dailyBreakdown && dailyBreakdown.querySelector('.grid') && dailyBreakdown.contains(day) && !isInDetailedBreakdown;

        if (isInMonthlyGrid) {
          // Don't hide monthly grid cells, just their content is filtered
          day.classList.remove('hidden');
        } else {
          // For weekly view and detailed breakdown, hide days with no visible content
          const dayItems = day.querySelectorAll('.calendar-item');
          const visibleDayItems = Array.from(dayItems).filter(item => !item.classList.contains('hidden'));
          if (visibleDayItems.length === 0) {
            day.classList.add('hidden');
          } else {
            day.classList.remove('hidden');
          }
        }
      });
    }

    // Show/hide no results message
    if (noResultsMessage) {
      if (visibleCount === 0 && filter !== 'all') {
        noResultsMessage.classList.remove('hidden');
      } else {
        noResultsMessage.classList.add('hidden');
      }
    }
  }
});
